import { render, staticRenderFns } from "./SurgicalCaseDetails.vue?vue&type=template&id=34141009&scoped=true&"
import script from "./SurgicalCaseDetails.vue?vue&type=script&lang=js&"
export * from "./SurgicalCaseDetails.vue?vue&type=script&lang=js&"
import style0 from "./SurgicalCaseDetails.vue?vue&type=style&index=0&id=34141009&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34141009",
  null
  
)

export default component.exports